export enum ButtonCode {
  Red1 = 0,
  Yellow1 = 1,
  Blue1 = 2,
  Red2 = 3,
  Yellow2 = 4,
  Blue2 = 5
};
